import { Component, Input, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

import { Observable } from 'rxjs';
import { map, throttleTime } from 'rxjs/operators';
import { UserInfo } from 'src/app/auth/models/user';
import { MapService } from 'src/app/services/map.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
})
export class FooterComponent implements OnInit {
  @Input() currentUser: UserInfo;
  @Input() fullScreenView: boolean;
  mouseMove$: Observable<TrimbleMaps.MapMouseEvent>;
  currentYear: number;
  throttleTime = 100;
  isLatLonShow$: Observable<boolean>;
  zoomLevel$: Observable<number>;
  constructor(private mapService: MapService, private router: Router) {}

  ngOnInit(): void {
    this.mouseMove$ = this.mapService.mouseMove$.pipe(
      throttleTime(this.throttleTime)
    );
    this.zoomLevel$ = this.mapService.mapLocation$.pipe(
      map((loc) => (loc?.zoom > 0 ? Math.floor(loc?.zoom) : 0))
    );
    this.currentYear = new Date().getFullYear();
    this.isLatLonShow$ = this.router.events.pipe(
      map((routerEvent) => {
        if (routerEvent instanceof NavigationEnd) {
          const isLatLonShow = Boolean(this.router.url.match('/?center'));
          return isLatLonShow;
        }
      })
    );
  }
}
